const isTestBank = window.location.origin.includes("testbank")
const REACT_APP_MAP_SUFFIX = "http://test-maps.newayz.com:8800"

const TEST_BANK_REACT_APP_MAP_SERVER_SPRITE = `${REACT_APP_MAP_SUFFIX}/maps/sprites/aimap/dark-v1/sprite`
const TEST_BANK_REACT_APP_MAP_SERVER_TILE = `${REACT_APP_MAP_SUFFIX}/maps/tilestream/v1/layers/landcover-zhejiang-20211221/tiles/{z}/{x}/{y}`
const TEST_BANK_REACT_APP_MAP_SERVER_GLYPHS = `${REACT_APP_MAP_SUFFIX}/maps/fonts/{fontstack}/{range}.pbf`

const MAP_SERVER_SPRITE = isTestBank
  ? TEST_BANK_REACT_APP_MAP_SERVER_SPRITE
  : process.env.REACT_APP_MAP_SERVER_SPRITE
const MAP_SERVER_TILE = isTestBank
  ? TEST_BANK_REACT_APP_MAP_SERVER_TILE
  : process.env.REACT_APP_MAP_SERVER_TILE
const MAP_SERVER_GLYPHS = isTestBank
  ? TEST_BANK_REACT_APP_MAP_SERVER_GLYPHS
  : process.env.REACT_APP_MAP_SERVER_GLYPHS

export const PROJECT_MODE = process.env.REACT_APP_MODE
// 是否农行环境模式
export const isNH = PROJECT_MODE === "NH"
// 是否为 WAYZ QA环境
export const isWAYZQA = process.env.REACT_WAYZ_QA === "true"

export const CustomerMapConfig = {
  MAP_SERVER_SPRITE,
  MAP_SERVER_TILE,
  MAP_SERVER_GLYPHS,
}

// mapbox token
export const MAP_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
